import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import IntegrationPreferenceService, {
  IntegrationPreferenceProps
} from 'services/hooks/integration-preference-service';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import { Table } from '../Common/Table';
import Save from './IntegrationPreferenceForms/save';
import Delete from './IntegrationPreferenceForms/delete';
import { FilterSelect } from 'utils/FilterSelectUtils';
import IntegrationService, { IntegrationProps } from 'services/hooks/integration-service';

export default function IntegrationPreferencesSaveMode() {
  const [getPreferencesResult, setGetPreferencesResult] = useState<
    IntegrationPreferenceProps[] | null
  >([]);
  const [integrationsList, setIntegrationsList] = useState<IntegrationProps[] | null>();

  const {
    isLoading: isLoadingPreferences,
    refetch,
    data: preferencesData
  } = useQuery<IntegrationPreferenceProps[], Error>(
    'preferences',
    () => IntegrationPreferenceService.findAllIntegrationPreferences(),
    {
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  const { refetch: integrationRefetch, data: integrationData } = useQuery<
    IntegrationProps[],
    Error
  >('integrations', IntegrationService.findAllIntegrations, {
    onError: (err: any) => {
      console.log(err.response?.data || err);
    }
  });

  useEffect(() => {
    if (preferencesData && Array.isArray(preferencesData)) {
      refetch();
      setGetPreferencesResult(preferencesData);
    }
    if (integrationData && Array.isArray(integrationData)) {
      integrationRefetch();
      setIntegrationsList(integrationData);
    }
  }, [integrationData, integrationRefetch, preferencesData, refetch]);

  const columns = React.useMemo(
    () => [
      {
        id: 'integrationname',
        Header: 'Integration Name',
        accessor: (row: { integrationUuid: string }) => {
          return integrationsList?.find((f: { uuid?: string }) => f?.uuid === row?.integrationUuid)
            ?.name;
        },
        Filter: FilterSelect
      },
      {
        id: 'emailrequired',
        Header: 'Email Status',
        accessor: (row: { emailRequired: boolean }) => {
          return row?.emailRequired ? 'True' : 'False';
        },
        disableFilters: true
      },
      {
        id: 'requiressecondauth',
        Header: 'SecondAuth Status',
        accessor: (row: { requiresSecondAuth: boolean }) => {
          return row?.requiresSecondAuth ? 'True' : 'False';
        },
        disableFilters: true
      },

      {
        id: 'actions',
        Header: 'Actions',
        accessor: (data: any) => data,
        Cell: (row: any) => {
          return (
            <div className="flex gap-4">
              <SecondaryButton
                onClick={() => {
                  row.setEditUUID(row.value.uuid);
                  row.setUpdateShowModal(true);
                }}
                buttonLabel="Edit"
                variant="default"
                size="px-4 w-auto"
              />
              <SecondaryButton
                onClick={() => {
                  row.setDeleteUUID(row.value.uuid);
                  row.setDeleteShowModal(true);
                }}
                buttonLabel="Delete"
                variant="default"
                size="px-4 w-auto"
              />
            </div>
          );
        },
        width: 150,
        disableFilters: true
      }
    ],
    [integrationsList]
  );

  if (isLoadingPreferences || !getPreferencesResult) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return !isLoadingPreferences && getPreferencesResult ? (
    <div className="preferences">
      <Table
        name="Preferences"
        columns={columns}
        data={getPreferencesResult}
        refetch={refetch}
        CreateForm={Save}
        DeleteForm={Delete}
        createQuery={IntegrationPreferenceService.createIntegrationPreference}
        updateQuery={IntegrationPreferenceService.updateIntegrationPreference}
        deleteQuery={IntegrationPreferenceService.deleteIntegrationPreferenceById}
        editQuery={IntegrationPreferenceService.findIntegrationPreferenceById}
        queryName="preferences"
        buttonName="Preference"
        toolTipMessage="Configure integration settings like email and authentication."
      />
    </div>
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
